<app-menu>
  <div class="cod-shell" [attr.data-theme]="themeMode">
    <div class="cod-page">
      
      <div class="cod-banner" *ngIf="errorMessage">
        <div class="cod-banner__icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div class="cod-banner__body">
          <div class="cod-banner__title">Unable to load this work order</div>
          <div class="cod-banner__text">{{ errorMessage }}</div>
        </div>
        <button class="cod-btn cod-btn--ghost" (click)="errorMessage = ''">Dismiss</button>
      </div>

      <div class="cod-loading" *ngIf="loading">
        <div class="cod-spinner"></div>
        <h2>Loading details...</h2>
      </div>

      <ng-container *ngIf="!loading && !errorMessage && fields.length > 0">
        
        <header class="cod-header">
          <div class="cod-header__main">
            <div class="cod-eyebrow">Carrier Order Details</div>
            <h1 class="cod-title">Work Order {{ alternateRef || 'Details' }}</h1>
            
            <div class="cod-meta-tags">
              <span class="cod-tag cod-tag--blue" *ngIf="alternateRef">
                <i class="fa-solid fa-hashtag"></i> {{ alternateRef }}
              </span>
              <span class="cod-tag">
                <i class="fa-solid fa-fingerprint"></i> {{ ladingUuid }}
              </span>
              <span class="cod-tag">
                <i class="fa-solid fa-pen-to-square"></i> {{ editableFieldCount }} editable
              </span>
            </div>
          </div>

          <div class="cod-header__actions">
            <button class="cod-btn cod-btn--ghost" (click)="toggleTheme()">
              <i [class]="getThemeIcon()"></i> {{ getThemeLabel() }}
            </button>
            <button class="cod-btn cod-btn--primary" (click)="loadData()" [disabled]="loading || saving">
              <i class="fa-solid fa-arrows-rotate"></i> Refresh
            </button>
          </div>
        </header>

        <div class="cod-kpi-strip" *ngIf="summaryItems.length > 0">
          <div class="cod-kpi" *ngFor="let item of summaryItems">
            <div class="cod-kpi__label">
              <i [class]="item.icon"></i> {{ item.label }}
            </div>
            <div class="cod-kpi__value">{{ item.value }}</div>
          </div>
        </div>

        <section class="cod-section" *ngIf="getModalFields().length > 0">
          <h2 class="cod-section__title">Quick Workflows</h2>
          <div class="cod-workflow-grid">
            <button *ngFor="let field of getModalFields(); trackBy: trackByField" class="cod-workflow-card" (click)="openModal(field)">
              <div class="cod-workflow-card__icon">
                <i [class]="getModalIcon(field)"></i>
              </div>
              <div class="cod-workflow-card__content">
                <h3>{{ field.headerName }}</h3>
                <p>{{ getModalLabel(field) }}</p>
              </div>
              <div class="cod-workflow-card__arrow">
                <i class="fa-solid fa-arrow-right"></i>
              </div>
            </button>
          </div>
        </section>

        <div class="cod-data-layout">
          <article *ngFor="let group of groupedFields; trackBy: trackByGroup" class="cod-card">
            
            <div class="cod-card__header">
              <div class="cod-card__icon" [attr.data-accent]="group.accent">
                <i [class]="group.icon"></i>
              </div>
              <h2 class="cod-card__title">{{ group.title }}</h2>
            </div>
            
            <div class="cod-grid">
              <div *ngFor="let field of group.fields; trackBy: trackByField" 
                   class="cod-field" 
                   [class.cod-field--wide]="shouldSpanWide(field)">
                
                <div class="cod-field__label">
                  {{ field.headerName }}
                </div>

                <div class="cod-field__body">
                  
                  <div *ngIf="editingField !== field.dbField" class="cod-value-wrapper">
                    
                    <button
                      *ngIf="field.inputType === 'checkbox' && isInlineEditable(field)"
                      class="cod-badge cod-badge--interactive"
                      [class.cod-badge--success]="isChecked(field.value)"
                      [disabled]="togglingField === field.dbField"
                      (click)="toggleCheckbox(field)"
                      title="Click to toggle"
                    >
                      <i [class]="isChecked(field.value) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                      {{ togglingField === field.dbField ? 'Updating...' : (isChecked(field.value) ? 'Yes' : 'No') }}
                    </button>

                    <span
                      *ngIf="field.inputType === 'checkbox' && !isInlineEditable(field)"
                      class="cod-badge"
                      [class.cod-badge--success]="isChecked(field.value)"
                    >
                      <i [class]="isChecked(field.value) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                      {{ isChecked(field.value) ? 'Yes' : 'No' }}
                    </span>

                    <button *ngIf="field.inputType !== 'modal' && field.inputType !== 'checkbox' && isInlineEditable(field)" 
                            class="cod-value-interactive" 
                            [class.cod-text-empty]="field.displayValue === 'Not provided'"
                            (click)="startEdit(field)"
                            title="Click to edit">
                      <span class="cod-value-text">{{ field.displayValue }}</span>
                    </button>

                    <span *ngIf="field.inputType !== 'modal' && field.inputType !== 'checkbox' && !isInlineEditable(field)" 
                          class="cod-value-static"
                          [class.cod-text-empty]="field.displayValue === 'Not provided'">
                      {{ field.displayValue }}
                    </span>
                  </div>

                  <div *ngIf="editingField === field.dbField && field.inputType !== 'checkbox'" class="cod-editor">
                    <ng-container [ngSwitch]="field.inputType">
                      <input *ngSwitchCase="'date'" type="date" class="cod-input" [(ngModel)]="editValue" (keyup.enter)="saveEdit(field)" (keyup.escape)="cancelEdit()" autoFocus />
                      <input *ngSwitchDefault [type]="field.inputType === 'number' ? 'number' : 'text'" class="cod-input" [(ngModel)]="editValue" (keyup.enter)="saveEdit(field)" (keyup.escape)="cancelEdit()" autoFocus />
                    </ng-container>

                    <div class="cod-editor-actions">
                      <button class="cod-btn cod-btn--sm cod-btn--primary" (click)="saveEdit(field)" [disabled]="saving">
                        <i class="fa-solid fa-check" *ngIf="!saving"></i>
                        {{ saving ? 'Saving...' : 'Save' }}
                      </button>
                      <button class="cod-btn cod-btn--sm cod-btn--ghost" (click)="cancelEdit()" [disabled]="saving">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </article>
        </div>

      </ng-container>

      <div *ngIf="!loading && !errorMessage && fields.length === 0" class="cod-empty">
        <i class="fa-solid fa-folder-open cod-empty__icon"></i>
        <h3>No fields available</h3>
        <p>The grid configuration didn't return any visible fields for this record.</p>
      </div>

    </div>
  </div>
</app-menu>
